__turbopack_context__.v({
  "className": "poppins_feccbe6d-module__3eiDMW__className",
});
